import { getElement, forceUpdate } from "@stencil/core";
import { SySiteI18n } from "./sy-site-i18n"

// todo add lista de eventos escutáveis
export function i18nUpdateComponent() {
    return (target: any, _propertyKey: string) => {
        const { componentWillLoad } = target;
        target.componentWillLoad = async function () {
            SySiteI18n.i18n.on('languageChanged', _lang => {
                const host = getElement(this);
                forceUpdate(host);
            });
            return componentWillLoad && componentWillLoad.call(this);
        };
    };
}
